module.exports = __webpack_public_path__ + "img/cal-shot.41dcbfab.png";